@let inspections = ($inspections | async) || [];
<!---->
@let fetched = ($fetched | async);
<!---->

@if (!fetched) {
<loading title="Fetching inspections..." />
}
<!---->
@if (inspections.length) {
<div class="table-container ms-2">
  <table mat-table [dataSource]="inspections" class="mat-elevation-z8">
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let element">
        {{ element.createdAt | date }}
      </td>
    </ng-container>
    <ng-container matColumnDef="images">
      <th mat-header-cell *matHeaderCellDef>Images</th>
      <td mat-cell *matCellDef="let element">
        @for (image of element.images; track $index;) {
        <img [src]="image.imageUrl" class="inspection-image" />
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="comment">
      <th mat-header-cell *matHeaderCellDef>Comment</th>
      <td mat-cell *matCellDef="let element">{{ element.comment }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
}
<!---->
@if (!inspections.length && fetched) {
<div class="center">No inspections found</div>
}
